import auth from '@/router/auth'
import ItemIndex from '@/components/items/Index'
import ItemCreate from '@/components/items/Create'
import ItemUpdate from '@/components/items/Update'
import ItemShow from '@/components/items/Show'

export default [
  {
    path: '/items',
    name: 'items-index',
    component: ItemIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/items/create',
    name: 'items-create',
    component: ItemCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/items/update/:course_id',
    name: 'items-update',
    component: ItemUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/items/show/:course_id',
    name: 'items-show',
    component: ItemShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/items/router.js